import {NgModule} from "@angular/core";
import {NewsService} from "./services/news-service/news-service";
import {NewsIconComponent} from "./components/news-icon/news-icon";
import {CommonModule} from "@angular/common";

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    NewsService
  ],
  declarations: [
    NewsIconComponent
  ],
  exports: [
    NewsIconComponent
  ]
})
export class SellionsNewsModule {}



// WEBPACK FOOTER //
// ./src/modules/news/news.module.ts